<template>
    <!-- <v-container fill-height> -->
    <v-row class="justify-center align-center">
        <!-- min-height:200px;max-height:300px; -->
        <v-card color="#0A7EA5" style="min-height:200px;width:100%;" fill-height>
          <v-row class="mt-5 ml-5">
            <v-col cols="12">
                <v-btn text dark type="submit" color="#ffffff" width="100" @click="$router.back()">
                    <v-icon
                        left
                        dark
                    >
                        mdi-chevron-left
                    </v-icon>
                    Back
                </v-btn>
                </v-col>
            </v-row>
            <v-row class="justify-center align-center text-center ma-2">
                <v-col cols="12">
                    <h1 class="white--text">Company Registration</h1>
                </v-col>
            </v-row>
            <v-row class="justify-center align-center text-center ma-2">
                <v-col col="12">
                    <h3 class="white--text">Register now to get started with DTime</h3>
                </v-col>
            </v-row>
             
        </v-card>
        <v-container class="justify-start align-start text-start mt-5 maginCon">
            <v-row>
                <v-col cols="12" md="12">
                    <span style="font-size: 18px; font-weight: bold;">Personal Information</span><span style="font-size: 18px; font-weight: bold; color: red;"> *</span>
                </v-col>
            </v-row>
            <v-row >
                <v-col cols="12" md="4">
                    <v-text-field
                        v-model="Firstname"
                        outlined
                        dense
                        label="Firstname"
                        required
                        ref="Firstname"
                    ></v-text-field>
                </v-col>
                <v-col cols="12" md="4" class="responsive-marginCol">
                    <v-text-field
                        v-model="Lastname"
                        outlined
                        dense
                        label="Lastname"
                        ref="Lastname"
                    ></v-text-field>
                </v-col>
                <!-- <v-col cols="12" md="4" class="responsive-marginCol">
                    <v-menu
                        v-model="menu"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        transition="scale-transition"
                        offset-y
                        min-width="auto"
                        >
                        <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                            v-model="computedDatePOFormatted"
                            label="Date of Birth"
                            append-icon="mdi-calendar"
                            readonly
                            dense
                            outlined
                            v-bind="attrs"
                            v-on="on"
                            ></v-text-field>
                        </template>
                        <v-date-picker
                            v-model="Date_of_Birth"
                            @input="menu = false"
                        ></v-date-picker>
                        </v-menu>
                </v-col> -->
                <v-col cols="12" md="4" class="responsive-marginCol">
                    <v-text-field
                        v-model="Email"
                        outlined
                        dense
                        label="Email"
                        ref="Email"
                        :rules="emailRules"
                    ></v-text-field>
                </v-col>
            </v-row>
            <v-row class="responsive-margintop">
                <v-col cols="12" md="4">
                    <v-text-field
                        v-model="Username"
                        outlined
                        dense
                        label="Username"
                        ref="Username"
                    ></v-text-field>
                </v-col>
                <v-col cols="12" md="4" class="responsive-marginCol">
                    <v-text-field
                        v-model="Password"
                        outlined
                        dense
                        label="Password"
                        :append-icon="isShowPassword ? 'visibility' : 'visibility_off'"
                        @click:append="isShowPassword = !isShowPassword"
                        :type="isShowPassword ? 'text' : 'password'"
                        ref="Password"
                        :rules="passwordRules"
                    ></v-text-field>
                </v-col>
                <v-col cols="12" md="4" class="responsive-marginCol">
                    <v-text-field
                        v-model="Confirm_Password"
                        outlined
                        dense
                        label="Confirm Password"
                        :append-icon="isShowPassconfirmword ? 'visibility' : 'visibility_off'"
                        @click:append="isShowPassconfirmword = !isShowPassconfirmword"
                        :type="isShowPassconfirmword ? 'text' : 'password'"
                        ref="Confirm_Password"
                        :rules="confirmpasswordRules"
                    ></v-text-field>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" md="12">
                    <span style="font-size: 18px; font-weight: bold;">Company Information</span> <span style="font-size: 18px; font-weight: bold; color: red;"> *</span>
                </v-col>
            </v-row>
            <v-row >
                <v-col cols="12" md="4">
                    <v-text-field
                        v-model="Company_Name"
                        outlined
                        dense
                        label="Company Name"
                        ref="Company_Name"
                    ></v-text-field>
                </v-col>
                <v-col cols="12" md="8" class="responsive-marginCol">
                    <v-text-field
                        v-model="Company_Address"
                        outlined
                        dense
                        label="Company Address"
                        ref="Company_Address"
                    ></v-text-field>
                </v-col>
            </v-row>
            <v-row class="responsive-margintop">
                <v-col cols="12" md="4">
                    <v-text-field
                        v-model="Company_Branch"
                        outlined
                        dense
                        label="Branch"
                        ref="Company_Branch"
                    ></v-text-field>
                </v-col>
                <v-col cols="12" md="4" class="responsive-marginCol">
                    <v-text-field
                        v-model="Company_Email"
                        outlined
                        dense
                        label="Company Email"
                        ref="Company_Email"
                        :rules="emailRules"
                    ></v-text-field>
                </v-col>
                <v-col cols="12" md="4" class="responsive-marginCol">
                    <v-text-field
                        v-model="Company_Telephone_Number"
                        outlined
                        dense
                        label="Telephone Number"
                        ref="Company_Telephone_Number"
                        :rules="telRules"
                    ></v-text-field>
                </v-col>
            </v-row>
            <v-row class="responsive-margintop">
                <v-col cols="10" md="4" >
                    <v-text-field
                        v-model="Company_Code"
                        outlined
                        dense
                        label="Company Code"
                        ref="Company_Code"
                        :counter="6"
                        :rules="comcodeRules"
                    ></v-text-field>
                </v-col>
                <v-col cols="2" md="1" >
                    <v-icon 
                        class="custom-icon"
                        @mouseover="desComCode()"
                    >mdi-help-circle</v-icon>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" md="12">
                    <span style="font-size: 18px; font-weight: bold;">Invoice Information</span> <span style="font-size: 18px; font-weight: bold; color: red;"> *</span>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" md="12">
                    <label>
                        <input type="checkbox" v-model="checkSameComInv"> Same as Company Information
                    </label>
                </v-col>
            </v-row>
            <div>
                <v-row >
                    <v-col cols="12" md="4">
                        <v-text-field
                            v-model="INV_Company_Name"
                            outlined
                            dense
                            label="Company Name"
                            ref="INV_Company_Name"
                        ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="8" class="responsive-marginCol">
                        <v-text-field
                            v-model="Invoice_Address"
                            outlined
                            dense
                            label="Invoice Address"
                            ref="Invoice_Address"
                        ></v-text-field>
                    </v-col>
                </v-row>
                <v-row class="responsive-margintop">
                    <v-col cols="12" md="4">
                        <v-text-field
                            v-model="INV_Company_Name_TH"
                            outlined
                            dense
                            label="Company Name Thai"
                            ref="INV_Company_Name_TH"
                        ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="4" class="responsive-marginCol">
                        <v-text-field
                            v-model="INV_Branch"
                            outlined
                            dense
                            label="Branch"
                            ref="INV_Branch"
                        ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="4" class="responsive-marginCol">
                        <v-text-field
                            v-model="INV_Email"
                            outlined
                            dense
                            label="Company Email"
                            ref="INV_Email"
                            :rules="emailRules"
                        ></v-text-field>
                    </v-col>

                </v-row>
                <v-row class="responsive-margintop">
                    <v-col cols="12" md="4" >
                        <v-text-field
                            v-model="INV_Telephone_Number"
                            outlined
                            dense
                            label="Telephone Number"
                            ref="INV_Telephone_Number"
                            :rules="telRules"
                        ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="4" class="responsive-marginCol">
                        <v-text-field
                            v-model="INV_Tax_ID"
                            outlined
                            dense
                            label="Tax ID"
                            ref="INV_Tax_ID"
                            :rules="numberRules"
                        ></v-text-field>
                    </v-col>
                </v-row>

            </div>
            <v-row>
                <v-col cols="12" md="12" class="responsive-marginCol txtbuttom">
                    <v-btn
                        type="submit"
                        rounded
                        depressed
                        max-width="200px"
                        width="100%"
                        style="
                            background-color: #0A7EA5; /* เปลี่ยนสีพื้นหลัง */
                            border-color: #0A7EA5;
                            color: white;
                        "
                        @click="openDialogRegister()"
                    >
                        Register
                    </v-btn>
                </v-col>
            </v-row>
            <br />
        </v-container>

  
        <v-dialog v-model="dialogDecComCode" width="80%" max-width="500px">
            <v-card>
                <v-card-title class="headline">
                    <span 
                        style="
                            font-size: 18px;
                            font-weight: bold;
                        "
                    >
                        Company Code
                    </span>
                </v-card-title>
                <v-card-text>
                    Your company code must be a maximum of 6 digits. This code will be used to identify employees of your company during the login process. Ensure that the code is unique and easily recognizable for your organization.
                </v-card-text>
                <!-- <v-card-actions class="justify-center align-center text-center">
                    <v-btn color="primary" text @click="closeDialogDesComCode">close</v-btn>
                </v-card-actions> -->
            </v-card>
        </v-dialog>
        <v-dialog v-model="dialogRegister" min-width="320px" max-width="450px" >
            <v-card>
                <v-card-title class="text-center"></v-card-title>
                <v-card-text class="text-center">
                    <br />
                    <span style="font-size: 18px; font-weight: bold;">you sure want to submit?</span><br /><br />
                    <span style="font-size: 16px; font-weight: bold;">Tax ID and Company Code <u>cannot</u> be changed.</span>
                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="green darken-1" text @click="openVerifyEmail()">Register</v-btn>
                    <v-btn color="red darken-1" text @click="closeDialogRegister()">Cancle</v-btn>
                </v-card-actions>
            </v-card>
            </v-dialog>
        <v-dialog v-model="dialogVerifyMail" min-width="320px" max-width="450px" height="100%">
            <v-card>
                <v-card-title class="text-center"></v-card-title>
                <v-card-text class="text-center">
                    <br />
                    <v-row >
                        <v-col md="12">
                            <span style="font-size: 20px; font-weight: bold;"><u>Verify Email</u></span>
                        </v-col>
                    </v-row>
                    <v-row class="mt-0">
                        <v-col md="12" >
                            <span style="font-size: 16px; font-weight: bold;">{{ Email }}</span>
                        </v-col>
                    </v-row>
                    <v-row >
                        <v-col md="10" offset="1">
                            <v-text-field
                                v-model="opt_number"
                                outlined
                                dense
                                label="OTP"
                                required
                                ref="OTP"
                            ></v-text-field>
                        </v-col>
                    </v-row>
                </v-card-text>

                <v-card-actions >
                    <v-spacer></v-spacer>
                    <v-row class="d-flex align-center justify-center">
                        <v-col md="4" class="align-center justify-center">
                            <v-btn color="green darken-1" text @click="verifyEmail()">Verify</v-btn>
                        </v-col>
                        <v-col md="4" class="align-center justify-center">
                            <v-btn color="blue darken-1" text @click="sendVerifyEmail()">Send Again</v-btn>
                        </v-col>
                        <v-col md="4" class="align-center justify-center">
                            <v-btn color="red darken-1" text @click="closeVerifyEmail()">Cancle</v-btn>
                        </v-col>
                    </v-row>
                    <br />
                    <br />
                </v-card-actions>
            </v-card>
            </v-dialog>
        <SuccessDialog
            :status="dialogAdd"
            :text_color="text_color"
            :title="title"
            :message="message"
        />
        <SuccessDialogPush
          :status="dialogAdd"
          :text_color="text_color"
          :title="title"
          :message="message"
          :link="link"
        />
    </v-row>
    <!-- </v-container> -->
</template>
  
<script>
    import api from "@/services/api";
    import { server } from "@/services/constants";
    import SuccessDialog from "@/components/cards/SuccessDialog";
    import SuccessDialogPush from "@/components/cards/SuccessDialogPush";
    import unity from "@/unity/unity";
    
    export default {
        mounted() {
         if (localStorage.getItem(server.USER_ID) && api.isLoggedIn()) {
      this.$router.push("/");
    } else {
    }
        
            this.$hideLoader();
        },
        components: { 
            SuccessDialog,
            SuccessDialogPush,
        },
        computed: {
            // computedDatePOFormatted() {
            //     return unity.formatDate(this.Date_of_Birth);
            // },
        },
        data() {
            return {
                text_color: "text-h5 green--text text-center",
                title: "green",
                message: "green",
                link: "",
                dialogAdd: false,
                dialogDecComCode: false,
                dialogRegister: false,
                dialogVerifyMail: false,
                checkDialogRegister: 0,
                opt_number: "",
                opt_number_check: "",
                //get value
                Firstname: "",
                Lastname: "",
                // Date_of_Birth:  new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
                // .toISOString()
                // .substr(0, 10),
                Email: "",
                Username: "",
                Password: "",
                Confirm_Password: "",

                //company
                Company_Name: "",
                Company_Address: "",
                Company_Branch: "",
                Company_Email: "",
                Company_Telephone_Number: "",
                Company_Code: "",

                //INV
                INV_Company_Name: "",
                INV_Company_Name_TH: "",
                Invoice_Address: "",
                INV_Branch: "",
                INV_Email: "",
                INV_Telephone_Number: "",
                INV_Tax_ID: "",
                
                checkSameComInv: false,

                //show hide password
                isShowPassword: false,
                isShowPassconfirmword: false,

                //date
                menu: false,
                //rules
                passwordRules: [
                    (v) =>{
 
                        return (this.Confirm_Password.trim() != "" && v != this.Confirm_Password.trim()) ? "Please check that the Password and Confirm Password" : true;

                    }
                ],
                confirmpasswordRules: [
                    (v) =>{
 
                        return (this.Password.trim() != "" && v != this.Password.trim()) ? "Please check that the Password and Confirm Password" : true;

                    }
                ],
                numberRules: [
                (v) =>
                    /^[0-9]+$/.test(v) || "Please Input Number Only",
                ],
                telRules: [
                (v) =>
                    /^[+]?([0-9]+)$/.test(v) || "Please Input Number Only",
                ],
                emailRules: [
                (v) =>
                    /^(([^<>()[\]\\.,;:\s@']+(\.[^<>()\\[\]\\.,;:\s@']+)*)|('.+'))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
                    v
                    ) || "Please enter a valid email address",
                ],
                comcodeRules: [
                    (v) =>{
                        return v.length > 6 ? "Please check that the Company Code" : true;
                    }
                ],
            };
        },
        watch: {
            checkSameComInv(newVal) {
             this.checkSameComInvChanged(newVal);
            }
        },
        methods: {
            async desComCode(){
                this.dialogDecComCode = true;
            },

            async checkMail(Email,Mode){
  
                if (
                    !/^(([^<>()[\]\\.,;:\s@']+(\.[^<>()\\[\]\\.,;:\s@']+)*)|('.+'))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
                        Email
                    )
                ) {
                    this.checkDialogRegister = 1;
                    this.$store.state.global_dialog = true;
                    this.setupAlertDialog(
                    true,
                    "Failed",
                    "Please Check  E-mail Format",
                    "text-h5 red--text text-center"
                    );
                    this.$refs[`${Mode}`].focus();
                    return;
                }

            },
            async checkPass(){
                if(this.Password.trim() != this.Confirm_Password.trim()){
                    this.checkDialogRegister = 1;
                    this.$store.state.global_dialog = true;
                    this.setupAlertDialog(
                    true,
                    "Failed",
                    "Please Check Password and Confirm Password",
                    "text-h5 red--text text-center"
                    );
                    this.$refs["Confirm_Password"].focus();
                    return;
                }

            },
            async checkComCode(){
                if(this.Company_Code.trim().length > 6){
                    this.checkDialogRegister = 1;
                    this.$store.state.global_dialog = true;
                    this.setupAlertDialog(
                    true,
                    "Failed",
                    "Please Check Company Code",
                    "text-h5 red--text text-center"
                    );
                    this.$refs["Company_Code"].focus();
                    return;
                }else {
                    const res_com = await api.getCompanyByComCode(this.Company_Code.trim())
                    console.log(res_com.data)
                    if(res_com.data.length > 0){
                        this.checkDialogRegister = 1;
                        this.$store.state.global_dialog = true;
                        this.setupAlertDialog(
                        true,
                        "Failed",
                        "Company Code Duplicated, Please Check Company Code",
                        "text-h5 red--text text-center"
                        );
                        this.$refs["Company_Code"].focus();
                        return;
                    }

                }

            },
            async checkNumber(value,mode){
                if( !(/^([0-9]+)$/).test(value) ){
                    this.checkDialogRegister = 1;
                    this.$store.state.global_dialog = true;
                    this.setupAlertDialog(
                    true,
                    "Failed",
                    "Please Input Tax ID Number Only",
                    "text-h5 red--text text-center"
                    );
                    this.$refs[`${mode}`].focus();
                    return;
                }else if(mode == `INV_Tax_ID`){
                    const res_taxid = await api.getCompanyByTaxId(value)
                    console.log(res_taxid.data)
                    if(res_taxid.data.length > 0){
                        this.checkDialogRegister = 1;
                        this.$store.state.global_dialog = true;
                        this.setupAlertDialog(
                        true,
                        "Failed",
                        "Company Tax ID Duplicated, Please Check Tax ID",
                        "text-h5 red--text text-center"
                        );
                        this.$refs[`${mode}`].focus();
                        return;
                    }
                }
            },
            async checkTel(value,mode){
                if( !(/^[+]?([0-9]+)$/).test(value) ){
                    this.checkDialogRegister = 1;
                    this.$store.state.global_dialog = true;
                    this.setupAlertDialog(
                    true,
                    "Failed",
                    "Please Input Telephone Number is Number Only",
                    "text-h5 red--text text-center"
                    );
                    this.$refs[`${mode}`].focus();
                    return;
                }
            },
            async checkPass(){
                if(this.Password.trim() != this.Confirm_Password.trim()){
                    this.checkDialogRegister = 1;
                    this.$store.state.global_dialog = true;
                    this.setupAlertDialog(
                    true,
                    "Failed",
                    "Please Check Password and Confirm Password",
                    "text-h5 red--text text-center"
                    );
                    this.$refs["Confirm_Password"].focus();
                    return;
                }

            },
            async checkSameComInvChanged (value){
                if (value) {
                    this.INV_Company_Name = this.Company_Name.trim();
                    this.Invoice_Address = this.Company_Address.trim();
                    this.INV_Branch = this.Company_Branch.trim();
                    this.INV_Email = this.Company_Email.trim();
                    this.INV_Telephone_Number = this.Company_Telephone_Number.trim();
                }else{
                    this.INV_Company_Name = "";
                    this.Invoice_Address = "";
                    this.INV_Branch = "";
                    this.INV_Email = "";
                    this.INV_Telephone_Number = "";
                }
            },
            async checkMailDup(email,mode,mode_focus){
                const res_check_mail_col = await api.getCompanyCol(email,mode)
                console.log(res_check_mail_col.data)
                if(res_check_mail_col.data.length > 0){
                    this.checkDialogRegister = 1;
                    this.$store.state.global_dialog = true;
                    this.setupAlertDialog(
                    true,
                        "Failed",
                        "Email Duplicated, Please Check Email",
                        "text-h5 red--text text-center"
                        );
                    this.$refs[`${mode_focus}`].focus();
                    return;
                }
            },
            async openDialogRegister(){
                if(this.Firstname.trim() == ""){
                    this.$store.state.global_dialog = true;
                    this.setupAlertDialog(
                    true,
                    "Failed",
                    "Please Check Firstname Data",
                    "text-h5 red--text text-center"
                    );
                    this.$refs["Firstname"].focus();
                    return;
                }
                if(this.Lastname.trim() == ""){
                    this.$store.state.global_dialog = true;
                    this.setupAlertDialog(
                    true,
                    "Failed",
                    "Please Check Lastname Data",
                    "text-h5 red--text text-center"
                    );
                    this.$refs["Lastname"].focus();
                    return;
                }
                if(this.Email.trim() == ""){
                    this.$store.state.global_dialog = true;
                    this.setupAlertDialog(
                    true,
                    "Failed",
                    "Please Check Email Data",
                    "text-h5 red--text text-center"
                    );
                    this.$refs["Email"].focus();
                    return;
                }
                if(this.Username.trim() == ""){
                    this.$store.state.global_dialog = true;
                    this.setupAlertDialog(
                    true,
                    "Failed",
                    "Please Check Username Data",
                    "text-h5 red--text text-center"
                    );
                    this.$refs["Username"].focus();
                    return;
                }
                if(this.Password.trim() == ""){
                    this.$store.state.global_dialog = true;
                    this.setupAlertDialog(
                    true,
                    "Failed",
                    "Please Check Password Data",
                    "text-h5 red--text text-center"
                    );
                    this.$refs["Password"].focus();
                    return;
                }
                if(this.Confirm_Password.trim() == ""){
                    this.$store.state.global_dialog = true;
                    this.setupAlertDialog(
                    true,
                    "Failed",
                    "Please Check Confirm Password Data",
                    "text-h5 red--text text-center"
                    );
                    this.$refs["Confirm_Password"].focus();
                    return;
                }
                if(this.Company_Name.trim() == ""){
                    this.$store.state.global_dialog = true;
                    this.setupAlertDialog(
                    true,
                    "Failed",
                    "Please Check Company Name Data",
                    "text-h5 red--text text-center"
                    );
                    this.$refs["Company_Name"].focus();
                    return;
                }
                if(this.Company_Address.trim() == ""){
                    this.$store.state.global_dialog = true;
                    this.setupAlertDialog(
                    true,
                    "Failed",
                    "Please check the invoice information again.",
                    "text-h5 red--text text-center"
                    );
                    this.$refs["Company_Address"].focus();
                    return;
                }
                if(this.Company_Branch.trim() == ""){
                    this.$store.state.global_dialog = true;
                    this.setupAlertDialog(
                    true,
                    "Failed",
                    "Please Check Branch Data",
                    "text-h5 red--text text-center"
                    );
                    this.$refs["Company_Branch"].focus();
                    return;
                }
                if(this.Company_Email.trim() == ""){
                    this.$store.state.global_dialog = true;
                    this.setupAlertDialog(
                    true,
                    "Failed",
                    "Please Check Company Email Data",
                    "text-h5 red--text text-center"
                    );
                    this.$refs["Company_Email"].focus();
                    return;
                }
                if(this.Company_Telephone_Number.trim() == ""){
                    this.$store.state.global_dialog = true;
                    this.setupAlertDialog(
                    true,
                    "Failed",
                    "Please Check Telephone Number Data",
                    "text-h5 red--text text-center"
                    );
                    this.$refs["Company_Telephone_Number"].focus();
                    return;
                }

                if(this.Company_Code.trim() == ""){
                    this.$store.state.global_dialog = true;
                    this.setupAlertDialog(
                    true,
                    "Failed",
                    "Please Check Company Code Data",
                    "text-h5 red--text text-center"
                    );
                    this.$refs["Company_Code"].focus();
                    return;
                }
                if(this.INV_Company_Name.trim() == ""){
                    this.$store.state.global_dialog = true;
                    this.setupAlertDialog(
                    true,
                    "Failed",
                    "Please Check Company Name Data",
                    "text-h5 red--text text-center"
                    );
                    this.$refs["INV_Company_Name"].focus();
                    return;
                }
                if(this.INV_Company_Name_TH.trim() == ""){
                    this.$store.state.global_dialog = true;
                    this.setupAlertDialog(
                    true,
                    "Failed",
                    "Please Check Company Name Thai Data",
                    "text-h5 red--text text-center"
                    );
                    this.$refs["INV_Company_Name_TH"].focus();
                    return;
                }
                if(this.Invoice_Address.trim() == ""){
                    this.$store.state.global_dialog = true;
                    this.setupAlertDialog(
                    true,
                    "Failed",
                    "Please check the invoice information again.",
                    "text-h5 red--text text-center"
                    );
                    this.$refs["Invoice_Address"].focus();
                    return;
                }
                if(this.INV_Branch.trim() == ""){
                    this.$store.state.global_dialog = true;
                    this.setupAlertDialog(
                    true,
                    "Failed",
                    "Please Check Branch Data",
                    "text-h5 red--text text-center"
                    );
                    this.$refs["INV_Branch"].focus();
                    return;
                }
                if(this.INV_Email.trim() == ""){
                    this.$store.state.global_dialog = true;
                    this.setupAlertDialog(
                    true,
                    "Failed",
                    "Please Check Company Email Data",
                    "text-h5 red--text text-center"
                    );
                    this.$refs["INV_Email"].focus();
                    return;
                }
                if(this.INV_Telephone_Number.trim() == ""){
                    this.$store.state.global_dialog = true;
                    this.setupAlertDialog(
                    true,
                    "Failed",
                    "Please Check Telephone Number Data",
                    "text-h5 red--text text-center"
                    );
                    this.$refs["INV_Telephone_Number"].focus();
                    return;
                }
                if(this.INV_Tax_ID.trim() == ""){
                    this.$store.state.global_dialog = true;
                    this.setupAlertDialog(
                    true,
                    "Failed",
                    "Please Check Tax ID Data",
                    "text-h5 red--text text-center"
                    );
                    this.$refs["INV_Tax_ID"].focus();
                    return;
                }
                this.checkDialogRegister = 0;
                await this.checkMail(this.Email.trim(),`Email`)
                await this.checkPass()
                await this.checkMail(this.Company_Email.trim(),`Company_Email`)
                await this.checkComCode()
                await this.checkMail(this.INV_Email.trim(),`INV_Email`)
                await this.checkNumber(this.INV_Tax_ID.trim(), `INV_Tax_ID`)
                await this.checkTel(this.Company_Telephone_Number.trim(), `Company_Telephone_Number`)
                await this.checkTel(this.INV_Telephone_Number.trim(), `INV_Telephone_Number`)
                await this.checkMailDup(this.Company_Email.trim(), `company_email`,`Company_Email`);
                await this.checkMailDup(this.INV_Email.trim(), `inv_company_email`,`INV_Email`);

                if(this.checkDialogRegister == 0){
                    this.dialogRegister = true;
                }
            },
            async closeDialogRegister(){
                this.dialogRegister = false;
            },
            async openVerifyEmail(){
                this.dialogRegister = false;
                this.$showLoader()
                var res_check_mail = await api.checkVerifyEmail({ email: this.Email})
                this.$hideLoader();
                // console.log(res_check_mail.datamessage)
                if(res_check_mail.data.message == "Have User"){
                    this.$store.state.global_dialog = true;
                    this.setupAlertDialog(
                        true,
                        "Failed",
                        "Please check the email, This email is  registered",
                        "text-h5 red--text text-center"
                    );
                    return;
                }else{
                    this.opt_number_check = res_check_mail.data.message;
                    this.dialogVerifyMail = true;
                }

            },
            async verifyEmail(){
                if(this.opt_number.trim() == ""){
                    this.$store.state.global_dialog = true;
                    this.setupAlertDialog(
                    true,
                    "Failed",
                    "Please Check OTP Number Data",
                    "text-h5 red--text text-center"
                    );
                    this.$refs["OTP"].focus();
                    return;
                }
               
                if(this.opt_number_check == this.opt_number){
                    this.dialogVerifyMail = false;
                    await this.saveRegister()
                }else{
                    this.$store.state.global_dialog = true;
                    this.setupAlertDialog(
                        true,
                        "Failed",
                        "OTP Number not Match",
                        "text-h5 red--text text-center"
                    );
                    return;
                }

            },
            async sendVerifyEmail(){
                this.$showLoader()
                    var res_send_check_mail = await api.checkVerifyEmail({ email: this.Email})
                    this.opt_number_check = res_send_check_mail.data.message;
                this.$hideLoader();
                this.$store.state.global_dialog = true;
                this.setupAlertDialog(
                    true,
                    "Check Email",
                    "Plase Check Your Email",
                    "text-h5 green--text text-center"
                );
                return;
            },
            async closeVerifyEmail(){
                this.dialogVerifyMail = false;
            },
            async saveRegister(){
                this.dialogRegister = false;
                var item_data = {
                    Firstname: this.Firstname.trim(),
                    Lastname: this.Lastname.trim(),
                    // Date_of_Birth:  this.Date_of_Birth,
                    Email: this.Email.trim(),
                    Username: this.Username.trim(),
                    Password: this.Password.trim(),
                    Confirm_Password: this.Confirm_Password.trim(),

                    //company
                    Company_Name: this.Company_Name.trim(),
                    Company_Address: this.Company_Address.trim(),
                    Company_Branch: this.Company_Branch.trim(),
                    Company_Email: this.Company_Email.trim(),
                    Company_Telephone_Number: this.Company_Telephone_Number.trim(),
                    Company_Code: this.Company_Code.trim(),

                    //INV
                    INV_Company_Name: this.INV_Company_Name.trim(),
                    INV_Company_Name_TH: this.INV_Company_Name_TH.trim(),
                    Invoice_Address: this.Invoice_Address.trim(),
                    INV_Branch: this.INV_Branch.trim(),
                    INV_Email: this.INV_Email.trim(),
                    INV_Telephone_Number: this.INV_Telephone_Number.trim(),
                    INV_Tax_ID: this.INV_Tax_ID.trim(),

                }
                this.$showLoader()
                const res_add_com = await api.addRegsiterCompany(item_data)
                if(res_add_com.status == 201){
                    this.$hideLoader();
                    this.$store.state.global_push_dialog = true;
                    this.setupAlertDialogPush(
                    true,
                    "Information Saved",
                    "Information successfully saved",
                    "text-h5 green--text text-center",
                    `/login`
                    );
                }else{
                    this.$hideLoader();
                    this.$store.state.global_dialog = true;
                    this.setupAlertDialog(
                        true,
                        "Information Saved",
                        "Information Save failed",
                        "text-h5 red--text text-center"
                    );
                    return;
                }
            },

            setupAlertDialog(status, title, message, text_color) {
                this.title = title;
                this.message = message;
                this.dialogAdd = status;
                this.text_color = text_color;
            },
            setupAlertDialogPush(status, title, message, text_color, link) {
                this.title = title;
                this.message = message;
                this.dialogAdd = status;
                this.text_color = text_color;
                this.link = link;
            },
        },
    };
</script>
  
<style scoped>
    .maginCon{
        margin-left: 50px !important;
        margin-right: 50px !important;
    }
    .responsive-margintop {
        margin-top: -20px !important;
    }

    .txtbuttom{
        text-align: center;
    }

    .custom-icon {
        color: #0A7EA5; /* สีเริ่มต้นของไอคอน */
        transition: color 0.3s; /* เพิ่มการเปลี่ยนแปลงสีให้มีความนุ่มนวล */
    }

    .custom-icon:hover {
        color: green; /* สีของไอคอนเมื่อมีการ hover */
    }
    @media (max-width: 960px) {
        .responsive-marginCol {
            margin-top: -20px !important;
        }
        .txtbuttom{
            text-align: center !important;;
        }
    }
    @media (max-width: 600px) {
        .maginCon{
            margin-left: 20px !important;
            margin-right: 20px !important;
        }
    }

    .heightsize60 {
        height: 60px;
    }
    
    .heightsize40 {
        height: 40px;
    }
</style>
  